import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { PageNotFoundComponent } from './pages/page-not-found/containers/page-not-found.component';
import { AppRoutingModule } from './app.routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PrequalGuard } from './pages/prequalifying-step-forms/containers/prequalifying-step-forms/prequal.guard';
import { StipulationService } from './pages/customer-account/services/stipulation.service';
import { DocumentUploaderService } from './pages/customer-account/services/document-uploader.service';
import { CustomerAccountGuard } from './pages/customer-account/services/customer-account.guard';
import { VehicleService } from './shared/services/vehicles/vehicle.service';
import { OfferGuard } from './shared/guards/offer.guard';


@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'wfs-direct'}),
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule
  ],
  providers: [
    OfferGuard,
    PrequalGuard,
    VehicleService,
    StipulationService,
    CustomerAccountGuard,
    DocumentUploaderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts